import React from "react";
import { LeaderboardPrizeSelectionType } from "interfaces";
import LeaderboardHowToPlay from "./LeaderboardHowToPlay";

interface LeaderboardDisclaimerProps {
  casinoProvider: string;
  type: LeaderboardPrizeSelectionType;
  ticketRate: number;
}

const LeaderboardDisclaimer: React.FC<LeaderboardDisclaimerProps> = ({
  casinoProvider,
  type,
  ticketRate,
}) => {
  switch (casinoProvider) {
    // case TheLeaderboardSourceKeys.hypedrop:
    //   return (
    //     <Container>
    //       <Content>
    //         <h6>CLOSURE NOTICE!</h6>
    //         <p>
    //           The HypeDrop team has decided to close the website operations for the foreseeable
    //           future. Kindly withdraw your account balance or order any items in your cart by 26th
    //           April 2024.
    //         </p>
    //         <a href="https://blog.hypedrop.com/closure-notice/" target="_blank">
    //           Read More
    //         </a>
    //       </Content>
    //     </Container>
    //   );

    default:
      return (
        <LeaderboardHowToPlay casinoProvider={casinoProvider} type={type} ticketRate={ticketRate} />
      );
  }
};

export default LeaderboardDisclaimer;
